import useEffectWithOptions from "./useEffectWithOptions";
import UseEffectOptions from "./UseEffectOptions";

export default function useDidMountEffect(effect: () => void, options?: UseEffectOptions): void {
    return useEffectWithOptions(effect, [], options);
}
